(function () {
    //this directive is an override of the pagination template from uIB to customize href and enables google to index the pages :)
    angular
        .module('meanApp')
        .directive('uibCustomPagination', function() {
            return {
                restrict: 'A',
                require: 'uibPagination',
                link: function ($scope, $element, $attr, uibPaginationCtrl) {
                    uibPaginationCtrl.createRecipeHrefLink = function (pageNum) {
                        return '/cool';
                    };
                }
            }
        });  
})();